module.exports = __webpack_public_path__ + "img/thigh.7f2543dc.png";